/**
 * Where the Secure your brand section's contract calls go: spark-esign at `window.config.esignApiUrl`,
 * read on every call (never once at load), so jest and the CT host can set `window.config` freely, and
 * nothing here reads Vite's build-time env (jest cannot parse it).
 *
 * Local and static builds get the spark-test URL from `public/assets/config/ini.js`; deployed spark-test
 * environments get it from the helm configmap's default, and other deployed environments (production)
 * from `spark_esign_api_url` in their deploy values. In dev, `VITE_ESIGN_API_URL`
 * (copied into `window.config` by `src/dev.js`) overrides it. With no URL, every call rejects and the
 * section shows the Load failed notice, never fake states.
 */

/** The spark-esign base URL, trimmed and without trailing slashes; `null` when absent or empty. */
export const esignApiUrl = (): string | null => {
  if (typeof window === 'undefined') return null;
  const configured = window.config?.esignApiUrl;
  if (typeof configured !== 'string') return null;
  const url = configured.trim().replace(/\/+$/, '');
  return url === '' ? null : url;
};
